import { useDataListContext } from './DataList';
import List, { type ListProps } from './List';

export default function DataListList<T extends Record<string, any>>(
  props: Omit<ListProps<T>, 'filterFields' | 'defaultFilters' | 'defaultSort' | 'defaultPageSize' | 'title'>
) {
  const { filterFields, defaultFilters, defaultSort, defaultPageSize, title } = useDataListContext<T>();
  return (
    <List<T>
      {...props}
      title={title}
      filterFields={filterFields}
      defaultFilters={defaultFilters}
      defaultSort={defaultSort}
      defaultPageSize={defaultPageSize}
    />
  );
}
